'use strict';

const dynamicPromos = require('./dynamicPromos');

const categoryLvl1List = Array.prototype.slice.call(document.querySelectorAll('.pages-nav__item'));
const categoryLvl2LinkList = Array.prototype.slice.call(document.querySelectorAll('.js-subnav-link'));
const dataAnimationHover = document.querySelector('[data-animation-hover]');
let mobileEventsInitialized = false;
let desktopEventsInitialized = false;

function categoryLvl1Toggle(categoryLvl1) {
    if (categoryLvl1.classList.contains('pages-nav__item--active')) {
        categoryLvl1.classList.remove('pages-nav__item--active');
    } else {
        // AOBC-4821: customer can expand only one category
        document.querySelectorAll('.pages-nav__item--active').forEach(nav => {
            nav.classList.remove('pages-nav__item--active');
        });
        categoryLvl1.classList.add('pages-nav__item--active');
    }
}

function categoryLvl2Toggle(categoryLvl2) {
    var parentTargetItems = categoryLvl2.querySelectorAll('.pages-subnav-level');

    for (var i = 0; i < parentTargetItems.length; i++) {
        if (parentTargetItems[i] !== categoryLvl2) {
            if (parentTargetItems[i].classList.contains('pages-subnav-level--open')) {
                parentTargetItems[i].classList.remove('pages-subnav-level--open');
            } else {
                parentTargetItems[i].classList.add('pages-subnav-level--open');
            }
        }
    }

    if (categoryLvl2.classList.contains('open')) {
        categoryLvl2.classList.remove('open');
    } else {
        categoryLvl2.classList.add('open');
    }
}

function initDom() {
    categoryLvl2LinkList.forEach(categoryLvl2Link => {
        // 2-nd lvl navigations are expanded by default
        categoryLvl2Toggle(categoryLvl2Link.closest('.pages-subnav__item'));
    });
}
// tab-focus
var navLink = $('.pages-nav .pages-nav__item');
navLink.on('focusin', function (e) {
    $(this).addClass('tab-focuss');
    event.stopPropagation();
});
navLink.on('focusout', function (e) {
    $(this).removeClass('tab-focuss');
});
// end tab-focus

// Checkboxes and radio buttons trigger by keypress
$(function() {
    $('.m-account__register-radio-label, .custom-form-element__checkbox-label').keypress(function(e) {
        $(this).trigger('click');
    });
});
// End Checkboxes and radio buttons trigger by keypress

// Trigger toggler element
$(function() {
    $('.c-toggler__element').keypress(function(e) {
        $(this).trigger('click');
    });
});
// End Trigger toggler element
function addTabIndexOnPageLoad() {
    if (window.innerWidth <= '1023') {
        $('ul.pages-nav li a').each(function(i) {
            if ($(this).attr('tabindex') === '-1') {
                return false;
            }
            $(this).attr('tabindex', '-1');
        });

        // Sign in button
        if ($('a.sign-in-btn').attr('tabindex') === '-1') {
            return false;
        }
        $('a.sign-in-btn').attr('tabindex', '-1');

        if ($('a.account-right-nav__contact').attr('tabindex') === '-1') {
            return false;
        }
        $('a.account-right-nav__contact').attr('tabindex', '-1');

        $('p.account-right-nav__content a').attr('tabindex', '-1');
    } else {
        $('ul.pages-nav li a').each(function(i) {
            if ($(this).attr('tabindex') === '0') {
                return false;
            }
            $(this).attr('tabindex', '0');
        });

        // Sign in button
        if ($('a.sign-in-btn').attr('tabindex') === '0') {
            return false;
        }
        $('a.sign-in-btn').attr('tabindex', '0');

        if ($('a.account-right-nav__contact').attr('tabindex') === '0') {
            return false;
        }
        $('a.account-right-nav__contact').attr('tabindex', '0');

        $('p.account-right-nav__content a').attr('tabindex', '0');
    }
}

function initListeners() {
    window.mqR.add(function (status) {
        const headerNavEl = document.querySelector('.header__nav');

        if (status.phone || status.tablet) {
            if (dataAnimationHover) {
                dataAnimationHover.classList.remove(dataAnimationHover.getAttribute('data-animation-hover'));
            }

            setTimeout(() => {
                const headerNavElPosition = headerNavEl.getBoundingClientRect();

                headerNavEl.style.maxHeight = `${window.innerHeight - headerNavElPosition.top}px`;
            }, 700);

            if (mobileEventsInitialized) {
                return;
            }

            categoryLvl1List.forEach(categoryLvl1 => {
                const hasSubNav = categoryLvl1.querySelector('.pages-subnav');
                const categoryLink = categoryLvl1.querySelector('.js-pages-nav__link');

                // expand if category has sub-navigation, otherwise - redirect to CLP
                if (hasSubNav) {
                    categoryLink.addEventListener('click', e => {
                        e.preventDefault();
                        categoryLvl1Toggle(categoryLvl1);
                    });
                }
            });

            // Handle 2-nd lvl categories navigation
            var categoryLvl1HasSubNav = document.getElementsByClassName('pages-nav__item has-subnav');

            if (typeof categoryLvl1HasSubNav[0] !== 'undefined') {
                categoryLvl1HasSubNav[0].addEventListener('click', e => clickEvents(e), false);
            }

            categoryLvl2LinkList.forEach(categoryLvl2Link => {
                categoryLvl2Link.addEventListener('click', function(e) {
                    const categoryLvl2 = categoryLvl2Link.closest('.pages-subnav__item');

                    e.preventDefault();
                    categoryLvl2Toggle(categoryLvl2);
                });
            });
            mobileEventsInitialized = true;
        }
        /**
        * @function
        * @description Unbind event of subcategory mobile navigation and handle the aria-expanded on desktop
         */
        if (status.desktop || status.desktopLarge) {
            var hasSubnav = document.getElementsByClassName('pages-nav__item has-subnav');
            var inSubNav  = document.getElementsByClassName('pages-subnav__link');
            var headerNav = document.getElementsByClassName('header__nav');

            headerNavEl.style.maxHeight = 'none';

            if (typeof hasSubnav[0] !== 'undefined') {
                hasSubnav[0].removeEventListener('click', e => clickEvents(e));

                hasSubnav[0].classList.add(inSubNav[0]).addEventListener('focus mouseenter', function() {
                    headerNav[0].setAttribute('aria-expanded', 'true');
                });

                hasSubnav[0].classList.add(inSubNav[0]).addEventListener('blur mouseleave', function() {
                    headerNav[0].attr('aria-expanded', 'false');
                });
            }

            if (dataAnimationHover) {
                dataAnimationHover.classList.add(dataAnimationHover.getAttribute('data-animation-hover'));
            }
        }
        /**
        * @function
        * @description Handle overflow navigation
        */
        if (status.phone || status.tablet) {
            var toggleButton = document.querySelector('.header__menu');
            var bodyWrapper = document.getElementById('wrapper');

            if (toggleButton && !desktopEventsInitialized) {
                toggleButton.addEventListener('click', function(e) {
                    if (bodyWrapper.classList.contains('is-overflowY')) {
                        bodyWrapper.classList.remove('is-overflowY');
                    } else {
                        bodyWrapper.classList.add('is-overflowY');
                    }

                    toggleButtonMenu(e);
                });

                desktopEventsInitialized = true;
            }
        }
    });

    function clickEvents(e) {
        var navBottom = document.getElementsByClassName('header__nav--bottom');

        // If the clicked element doesn't have the right selector, bail
        if (!event.target.matches('.click-me')) return;
        e.preventDefault();

        // Show an element
        var show = function (elem) {
            elem.style.display = 'block';
        };

        // Hide an element
        var hide = function (elem) {
            elem.style.display = 'none';
        };

        var navLink = e.target;
        var parentNavLink = navLink.closest('.pages-nav__item');

        document.body.classList.remove('subnav-active');
        show(navBottom);

        var parentNavigation = parentNavLink.parentNode;
        var parentNavigationItems = parentNavigation.querySelectorAll('.pages-nav__item');

        for (var i = 0; i < parentNavigationItems.length; i++) {
            if (parentNavigationItems[i] != parentNavLink) {
                parentNavigationItems[i].classList.remove('active');

                parentNavigationItems[i].querySelector('.has-subnav').classList.remove('active');
            }
        }

        if (parentNavLink.classList.contains('active')) {
            parentNavLink.classList.remove('active');
        } else {
            parentNavLink.classList.add('active');
        }

        if (navLink.classList.contains('active')) {
            navLink.classList.remove('active');
        } else {
            navLink.classList.add('active');
        }

        if (parentNavLink.classList.contains('active')) {
            document.body.classList.add('subnav-active');
            hide(navBottom);
        }
    }

    /**
     * @function
     * @description Handle the main navigation
     */
    var header = document.querySelector('.header');
    var headerPromotion = document.querySelector('.header-promotion');
    var headerNav = document.querySelector('.header__nav');
    var bodyEl = document.querySelector('body');
    var headerMenu = document.querySelector('.header__menu');
    var hamburgerCssClass = 'header__menu--toggle';
    var navigationCssClass = 'header__nav--open';
    var headerPromotionHeight = 0;

    if (headerPromotion) {
        headerPromotionHeight = headerPromotion.clientHeight;
    }

    function toggleButtonMenu(e) {
        function findAncestor(el, sel) {
            while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, sel)));
            return el;
        }

        var thisToggleTarget = e.target.classList.contains('header__menu') ? e.target : findAncestor(e.target, '.header__menu');

        if (thisToggleTarget.classList.contains(hamburgerCssClass)) {
            thisToggleTarget.classList.remove(hamburgerCssClass);
        } else {
            thisToggleTarget.classList.add(hamburgerCssClass);
        }

        if (typeof headerNav !== 'undefined') {
            if (headerNav.classList.contains(navigationCssClass)) {
                headerNav.classList.remove(navigationCssClass);
                headerNav.style.display = 'none';
                // IE11 does not support multiple classes for element.classList.add/remove methods
                bodyEl.classList.remove('stop-scroll');
                bodyEl.classList.remove('modal-open');
                if (window.innerWidth <= '1023') {
                    $('ul.pages-nav li a').each(function(i) {
                        if ($(this).attr('tabindex') === '0') {
                            $(this).attr('tabindex', '-1');
                        }
                    });
                    if ($('a.sign-in-btn').attr('tabindex') === '0') {
                        $('a.sign-in-btn').attr('tabindex', '-1');
                    }
                    if ($('a.account-right-nav__contact').attr('tabindex') === '0') {
                        $('a.account-right-nav__contact').attr('tabindex', '-1');
                    }
                    if ($('p.account-right-nav__content a').attr('tabindex') === '0') {
                        $('p.account-right-nav__content a').attr('tabindex', '-1');
                    }
                }
            } else {
                headerNav.style.display = 'block';
                headerNav.classList.add(navigationCssClass);
                bodyEl.classList.add('modal-open');
                bodyEl.classList.add('stop-scroll');
                if (window.innerWidth <= '1023') {
                    $('ul.pages-nav li a').each(function(i) {
                        if ($(this).attr('tabindex') === '-1') {
                            $(this).attr('tabindex', '0');
                        }
                    });
                    if ($('a.sign-in-btn').attr('tabindex') === '-1') {
                        $('a.sign-in-btn').attr('tabindex', '0');
                    }
                    if ($('a.account-right-nav__contact').attr('tabindex') === '-1') {
                        $('a.account-right-nav__contact').attr('tabindex', '0');
                    }
                    if ($('p.account-right-nav__content a').attr('tabindex') === '-1') {
                        $('p.account-right-nav__content a').attr('tabindex', '0');
                    }
                }
            }
        }

        if (headerMenu.getAttribute('aria-expanded') === 'true') {
            thisToggleTarget.setAttribute('aria-expanded', 'false');
        } else {
            thisToggleTarget.setAttribute('aria-expanded', 'true');
        }
    }

    /**
     * @function
     * @description Handle the sticky header on scroll
     */
    window.addEventListener('scroll', function() {
        if (window.pageYOffset > headerPromotionHeight) {
            if (header != null) {
                header.classList.add('header--fixed');
            }

            if (headerPromotion != null) {
                headerPromotion.classList.add('ms-hide');
            }
        } else {
            if (header != null) {
                header.classList.remove('header--fixed');
            }

            if (headerPromotion != null) {
                headerPromotion.classList.remove('ms-hide');
            }
        }

        if (headerNav && headerPromotion) {
            if (headerPromotion.style.display == 'none' && headerNav.classList.contains('.header__nav--open')) {
                headerNav.classList.add('header__nav--no-header-promotion');
            } else {
                headerNav.classList.remove('header__nav--no-header-promotion');
            }
        }
    });

    /**
     * @function
     * @description Handle the click event on locale-switcher
     */
    $('body').on('click', '.header__locale-switcher.toggleable .current-locale', function() {
            $('.header__locale-switcher').toggleClass('open');
    });

    /**
     * @function
     * @description Handle the click event on an locale options in dropdown and modal
     */
    $('.locale-option, .locale-modal-option').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        var flagId = $(this).data('flagid');
        var cookieDomain = $('.current-locale').data('cookiedomain');
        const key = '_countryId';
        const value = flagId;
        const ttl = 60*60*24;
        document.cookie = key + '=' + value + ';max-age=' + ttl + ';domain=' + cookieDomain + ';path=/';
        window.location.href = url;
    });

    /**
     * @function
     * @description Close open country selector & modal when clicking outside these areas?
     */
    $('body').on('touchstart click', function (e) {
        if ($('.header__locale-switcher.open').length > 0 && $('.header__locale-switcher').has(e.target).length <= 0) {
            $('.header__locale-switcher').removeClass('open');
        }
        if ($('.locale-selection-modal.show').length > 0 && $('.locale-selection-modal-dialog').has(e.target).length <= 0) {
            $('.locale-selection-modal').removeClass('show').addClass('fade');
        }
    });

    /**
     * @function
     * @description Close dropdown when clicking on close X
     */
    $('.locale-selection-modal-header .close').on('touchstart click', function (e) {
        $('.locale-selection-modal').removeClass('show').addClass('fade');
    });
}

var header = {
    init: function() {
        initDom();
        addTabIndexOnPageLoad();
        dynamicPromos.default.init();

        if (window.mqR) {
            initListeners();
        } else {
            import(/* webpackChunkName: 'mq-respond' */'mq-respond').then(() => {
                window.mqR = window.mqR || new mqRes([
                    {
                        label: 'phone',
                        from: 0,
                        to: 767
                    },
                    {
                        label: 'tablet',
                        from: 768,
                        to: 1023
                    },
                    {
                        label: 'desktop',
                        from: 1024,
                        to: 1679
                    },
                    {
                        label: 'desktopLarge',
                        from: 1680
                    }
                ]);
                initListeners();
            });
        }
    }
};

module.exports = header;
